import { FillInputProps } from '../fillInput';
import { WysiwygInput } from 'framework/form';
import { useEffect, useRef } from 'react';

export const RichTextInput = ({
  value,
  onChange,
  onBlur,
  disabled,
  required,
  error,
  inputId,
}: FillInputProps<string, object>) => {
  const refreshData = useRef<((value: string) => void) | null>(null);
  const lastEditorValue = useRef(value);

  useEffect(() => {
    if (value === lastEditorValue.current) return;
    lastEditorValue.current = value;
    refreshData.current?.(value);
  }, [value]);

  return (
    <WysiwygInput
      source={inputId}
      label=""
      value={value}
      disabled={disabled}
      isRequired={required}
      errorMessages={error ? [''] : []}
      setRefreshDataCallback={(refresh: (value: string) => void) => {
        refreshData.current = refresh;
      }}
      onChangeCallback={values => {
        const nextValue = values[inputId] ?? '';
        lastEditorValue.current = nextValue;
        onChange(nextValue);
      }}
      validationCallback={onBlur}
    />
  );
};
